import apiClient from './client'
import type { Parte, CreateParteRequest, UpdateParteRequest, PaginatedResponse } from '@/types/parte'

export const partesApi = {
    getAll: (params?: { search?: string; estado?: 'abiertos' | 'cerrados'; idCliente?: string; idUsuario?: number; idAviso?: number; page?: number; pageSize?: number }) =>
        apiClient.get<PaginatedResponse<Parte>>('/partes', { params }).then((r) => r.data),

    getById: (id: number) =>
        apiClient.get<Parte>(`/partes/${id}`).then((r) => r.data),

    getReportHtml: (id: number) =>
        apiClient.get<string>(`/partes/${id}/report`, {
            params: { format: 'html' },
            responseType: 'text',
        }).then((r) => r.data),

    getReportPdf: (id: number) =>
        apiClient.get<Blob>(`/partes/${id}/report`, {
            params: { format: 'pdf' },
            responseType: 'blob',
        }).then((r) => r.data),

    create: (data: CreateParteRequest) =>
        apiClient.post<Parte>('/partes', data).then((r) => r.data),

    update: (id: number, data: UpdateParteRequest) =>
        apiClient.put<Parte>(`/partes/${id}`, data).then((r) => r.data),

    delete: (id: number) =>
        apiClient.delete(`/partes/${id}`),
}
